/* Eartheasy product-page calculators.
   Loaded by snippets/eh-soil-calculator.liquid and snippets/eh-seed-calculator.liquid.
   Each snippet embeds the product (product | json) and its custom.calculator metafield as JSON;
   this file does the maths and keeps the result in step with the selected variant.
   GA4 events go to the store's Google tag through dataLayer, the same way
   snippets/blog-promo-tracking.liquid does: no second tag is loaded. */
(function () {
  if (window.ehCalculatorsLoaded) return;
  window.ehCalculatorsLoaded = true;

  var GA4 = 'G-NZ1TWEWVTM';
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  function track(name, params) {
    params = params || {};
    params.send_to = GA4;
    gtag('event', name, params);
  }

  // ---- shared helpers -------------------------------------------------------------
  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function mainForm() {
    return document.querySelector('form.main-product-form') ||
      document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]');
  }
  // form.id would return the form's <input name="id">, not the form's own id attribute
  function formId(form) { return form.getAttribute('id'); }
  function currentVariantId() {
    var form = mainForm();
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  // The theme rewrites the hidden variant id whenever an option changes; follow it.
  function onVariantChange(callback) {
    var last = null;
    function check() {
      var id = currentVariantId();
      if (id && id !== last) { last = id; callback(id); }
    }
    check();
    // the theme sets the hidden id and fires "change" on it, then "variant:changed" on document
    document.addEventListener('change', function () { setTimeout(check, 50); }, true);
    document.addEventListener('variant:changed', function () { setTimeout(check, 50); });
    setInterval(check, 500);
  }
  // Run callback once the theme has switched to the given variant (it asks the server first).
  function whenVariant(id, callback) {
    var started = Date.now();
    (function wait() {
      if (currentVariantId() === String(id)) return setTimeout(callback, 400);
      if (Date.now() - started > 6000) return callback();
      setTimeout(wait, 100);
    })();
  }
  function findVariant(product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return product.variants[0];
  }
  function fmt(n, digits) {
    return n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  }
  // Every length in an option value, in inches. A number counts only with a unit right after it:
  //   "3' x 6'" -> [36, 72]   "16\" W x 31\" L" -> [16, 31]   "3' 6\"" -> [42]
  //   "5.5\" Tall" -> [5.5]   "Black", "Medium", "32 sq ft" -> []
  function lengthsIn(value) {
    var s = String(value == null ? '' : value).replace(/''/g, '"');
    var re = /(\d+(?:\.\d+)?)[\s-]*(?:('|’|′|ft\b|feet|foot)(?:\s*(\d+(?:\.\d+)?)\s*(?:"|”|″|in\b|inch(?:es)?))?|("|”|″|in\b|inch(?:es)?))/gi;
    var out = [], m;
    while ((m = re.exec(s))) {
      var n = parseFloat(m[1]);
      out.push(m[2] ? n * 12 + (m[3] ? parseFloat(m[3]) : 0) : n);
    }
    return out;
  }
  function sizeLabel(dims) {
    function part(inches) { return inches % 6 === 0 ? (inches / 12) + "'" : inches + '"'; }
    return part(dims[0]) + ' × ' + part(dims[1]) + ' × ' + dims[2] + '"';
  }

  // ---- "How Much Soil?" tab ----------------------------------------------------------
  // Volume source, first match wins:
  //   1. custom.calculator "variants": {"<variant id>": {"cuft": n}} or {"<id>": [W, L, H] in inches}
  //   2. the variant's own size options, only on products where they agree with the stored
  //      volumes (so a size added later to a rectangular bed still gets a number, while an
  //      L-shape or a kit with walkways shows the link to the full calculator instead)
  //   3. custom.calculator "all": [W, L, H] or {"cuft": n}, same for every variant
  // Options that never describe the soil box: colour, finish, trellis, wheels, legs, corners.
  var NOT_SIZE = /colou?r|finish|trellis|wheel|\bleg|corner|style|material|pack/i;
  // Lengths in the variant's options, split into the bed's plan (W, L) and its height.
  function sizeParts(product, variant) {
    var names = product.options || [];
    var plan = [], height = [];
    for (var i = 0; i < names.length; i++) {
      var name = typeof names[i] === 'string' ? names[i] : names[i].name;
      if (NOT_SIZE.test(name)) continue;
      var lengths = lengthsIn(variant.options && variant.options[i]);
      if (/height|depth|tall/i.test(name)) height = height.concat(lengths);
      else plan = plan.concat(lengths);
    }
    return { plan: plan, height: height };
  }
  // [W, L, H] in inches, or null unless exactly that is there: two plan lengths
  // ("3' x 6'", or Width and Length options) and one height or depth.
  function dimsFromOptions(product, variant) {
    var s = sizeParts(product, variant);
    if (s.plan.length === 2 && s.height.length === 1) return s.plan.concat(s.height);
    if (s.plan.length === 3 && !s.height.length) return s.plan;
    return null;
  }
  // The selected size as the sentence names it: "4' × 8' × 11\"", "10\" tall", or null
  function sizeText(product, variant, dims) {
    if (dims) return sizeLabel(dims);
    var s = sizeParts(product, variant);
    return !s.plan.length && s.height.length === 1 ? s.height[0] + '" tall' : null;
  }
  // true when every stored volume matches W x L x H from the options (within 3%)
  function optionsMatchStored(product, cfg) {
    var checked = 0;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var x = cfg.variants && cfg.variants[String(v.id)];
      if (!x || !x.cuft) continue;
      var d = dimsFromOptions(product, v);
      if (!d) return false;
      if (Math.abs(d[0] * d[1] * d[2] / 1728 - x.cuft) / x.cuft > 0.03) return false;
      checked++;
    }
    return checked > 0;
  }
  function soilVolume(product, cfg, variant, trustOptions) {
    var dims = dimsFromOptions(product, variant);
    var x = cfg.variants && cfg.variants[String(variant.id)];
    if (x == null && trustOptions) x = dims;
    if (x == null) x = cfg.all;
    if (x == null) return null;
    if (typeof x === 'number') return { cuft: x, dims: dims };
    if (x.cuft) return { cuft: x.cuft, dims: dims };
    if (x.length === 3) return { cuft: x[0] * x[1] * x[2] / 1728, dims: dims || x };
    return null;
  }

  function initSoil(root) {
    var product = readJSON(root, '[data-eh-product]');
    var cfg = readJSON(root, '[data-eh-config]') || {};
    if (!product || !product.variants) return;
    function set(selector, text) {
      var el = root.querySelector(selector);
      if (el) el.textContent = text;
    }
    var trustOptions = optionsMatchStored(product, cfg);
    function update(id) {
      var variant = findVariant(product, id);
      var r = soilVolume(product, cfg, variant, trustOptions);
      if (!r || !(r.cuft > 0)) { root.classList.add('is-empty'); return; }
      root.classList.remove('is-empty');
      var bags = Math.max(1, Math.ceil(r.cuft / 1.5 - 1e-9));
      // no clear size in the options: say "this bed" rather than guess one
      var size = sizeText(product, variant, r.dims);
      var lede = root.querySelector('[data-eh-lede]');
      if (lede) {
        lede.textContent = '';
        if (size) {
          var strong = document.createElement('strong');
          strong.textContent = size + ' bed';
          lede.appendChild(document.createTextNode('For the '));
          lede.appendChild(strong);
          lede.appendChild(document.createTextNode(' selected above you need about:'));
        } else {
          lede.textContent = 'For this bed you need about:';
        }
      }
      set('[data-eh-bags]', bags);
      set('[data-eh-bags-word]', bags === 1 ? 'bag' : 'bags');
      set('[data-eh-cuft]', fmt(r.cuft, 1));
      set('[data-eh-cuyd]', fmt(r.cuft / 27, 2));
      set('[data-eh-mix-soil]', fmt(r.cuft * 0.5, 1));
      set('[data-eh-mix-compost]', fmt(r.cuft * 0.3, 1));
      set('[data-eh-mix-potting]', fmt(r.cuft * 0.2, 1));
    }
    onVariantChange(update);

    var tabId = root.getAttribute('data-eh-tab');
    var tab = tabId && document.getElementById(tabId);
    var opened = false;
    if (tab) {
      tab.addEventListener('click', function () {
        if (opened) return;
        opened = true;
        track('calc_open', { calculator: 'soil', product_handle: product.handle });
      });
    }
    var addon = root.querySelector('[data-eh-addon]');
    if (addon) {
      addon.addEventListener('click', function () {
        track('calc_addon_click', { calculator: 'soil', product_handle: product.handle, addon: addon.getAttribute('data-eh-addon') });
      });
    }
    var full = root.querySelector('[data-eh-full]');
    if (full) {
      full.addEventListener('click', function () {
        track('calc_full_click', { calculator: 'soil', product_handle: product.handle });
      });
    }
  }

  // ---- "Not sure how many bags?" seed helper ---------------------------------------------
  // custom.calculator for seed products:
  //   by weight:   {"type": "seed", "rate_new": 5, "rate_overseed": 7.5, "unit_lb": 5}  (lb per 1,000 sq ft)
  //   by coverage: {"type": "seed"}  (each variant title states its coverage, e.g. "500 sq ft")
  //                or {"type": "seed", "variants": {"<variant id>": 500}}
  function coverage(cfg, variant) {
    var c = cfg.variants && cfg.variants[String(variant.id)];
    if (c) return c;
    var m = String(variant.title || '').replace(/,/g, '').match(/([\d.]+)\s*(?:sq\.?\s*ft|sqft|square\s*f(?:ee|oo)t)/i);
    return m ? parseFloat(m[1]) : null;
  }
  function unitLb(cfg, product, variant) {
    if (cfg.unit_lb) return cfg.unit_lb;
    var m = (String(variant.title) + ' ' + product.title).match(/([\d.]+)[\s-]*(?:lbs?|pounds?)\b/i);
    return m ? parseFloat(m[1]) : null;
  }
  // Sizes sold by area: the cheapest way to cover the lawn, read from today's prices and stock.
  // Prices like $79.99 x 2 against $159.99 leave near-ties, and a cent is not a reason to sell
  // less seed: among options within 1% of the cheapest, take the one that covers the most
  // ground, then the one with fewer packs.
  var NEAR_TIE = 0.01;
  function pickByCoverage(product, cfg, sqft) {
    var opts = [];
    product.variants.forEach(function (v) {
      var c = coverage(cfg, v);
      if (!c || v.available === false) return;
      var q = Math.max(1, Math.ceil(sqft / c - 1e-9));
      opts.push({ variant: v, qty: q, cost: v.price * q, cov: c });
    });
    if (!opts.length) return null;
    var min = Math.min.apply(null, opts.map(function (o) { return o.cost; }));
    var best = null;
    opts.forEach(function (o) {
      if (o.cost > min * (1 + NEAR_TIE)) return;
      var area = o.cov * o.qty, bestArea = best && best.cov * best.qty;
      if (!best || area > bestArea || (area === bestArea && (o.qty < best.qty || (o.qty === best.qty && o.cost < best.cost)))) best = o;
    });
    return best;
  }
  function selectVariant(variant) {
    var form = mainForm();
    if (!form || !variant.options) return;
    variant.options.forEach(function (value) {
      var radios = document.querySelectorAll('input[type="radio"][form="' + formId(form) + '"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === value) {
          if (!radios[i].checked) radios[i].click();
          return;
        }
      }
      var selects = document.querySelectorAll('select[form="' + formId(form) + '"], variant-selects select');
      for (var j = 0; j < selects.length; j++) {
        var opts = selects[j].options;
        for (var k = 0; k < opts.length; k++) {
          if (opts[k].value === value && selects[j].value !== value) {
            selects[j].value = value;
            selects[j].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }
    });
  }
  function setQuantity(qty) {
    var form = mainForm();
    var input = form && (document.querySelector('input[name="quantity"][form="' + formId(form) + '"]') ||
      form.querySelector('input[name="quantity"]'));
    if (!input) return false;
    input.value = qty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function initSeed(root) {
    var product = readJSON(root, '[data-eh-product]');
    var cfg = readJSON(root, '[data-eh-config]') || {};
    if (!product || !product.variants) return;
    var modal = root.querySelector('[data-eh-modal]');
    var area = root.querySelector('[data-eh-area]');
    var result = root.querySelector('[data-eh-result]');
    var big = root.querySelector('[data-eh-big]');
    var detail = root.querySelector('[data-eh-detail]');
    var apply = root.querySelector('[data-eh-apply]');
    var chips = root.querySelectorAll('[data-eh-mode]');
    var byWeight = !!cfg.rate_new;
    var mode = 'new';
    var plan = null;
    var reported = '';

    var rateEl = root.querySelector('[data-eh-rate]');
    if (rateEl) {
      if (byWeight) {
        var first = findVariant(product, currentVariantId());
        var unit0 = unitLb(cfg, product, first);
        var covers = unit0 ? unit0 / cfg.rate_new * 1000 : null;
        rateEl.textContent = (covers ? 'One ' + fmt(unit0, unit0 % 1 ? 1 : 0) + ' lb bag covers ' + fmt(covers, 0) + ' sq ft of new lawn' :
          'New lawn: ' + cfg.rate_new + ' lb per 1,000 sq ft') +
          (cfg.rate_overseed ? '. Overseeding takes ' + cfg.rate_overseed + ' lb per 1,000 sq ft.' : '.');
      } else {
        rateEl.textContent = 'Enter your lawn area and we will pick the size and quantity.';
      }
    }

    if (!byWeight || !cfg.rate_overseed) {
      var chipRow = root.querySelector('[data-eh-modes]');
      if (chipRow) chipRow.hidden = true;
    }

    function compute(sqft) {
      if (byWeight) {
        var variant = findVariant(product, currentVariantId());
        var rate = mode === 'overseed' && cfg.rate_overseed ? cfg.rate_overseed : cfg.rate_new;
        var lb = sqft / 1000 * rate;
        var unit = unitLb(cfg, product, variant);
        if (!unit) return null;
        var qty = Math.max(1, Math.ceil(lb / unit - 1e-9));
        return {
          variant: variant, qty: qty,
          big: qty + ' × ' + fmt(unit, unit % 1 ? 1 : 0) + ' lb ' + (qty === 1 ? 'bag' : 'bags'),
          detail: fmt(lb, 1) + ' lb of seed for ' + fmt(sqft, 0) + ' sq ft'
        };
      }
      var best = pickByCoverage(product, cfg, sqft);
      if (!best) return null;
      return {
        variant: best.variant, qty: best.qty,
        big: best.qty + ' × ' + best.variant.title,
        detail: 'Covers ' + fmt(best.cov * best.qty, 0) + ' sq ft'
      };
    }
    function render() {
      var sqft = parseFloat(String(area.value).replace(/[^0-9.]/g, ''));
      plan = sqft > 0 ? compute(sqft) : null;
      if (!plan) { result.classList.remove('is-on'); apply.hidden = true; return; }
      big.textContent = plan.big;
      detail.textContent = plan.detail;
      result.classList.add('is-on');
      apply.hidden = false;
      apply.textContent = 'Set quantity to ' + plan.qty;
      var key = sqft + '|' + mode;
      if (key !== reported) {
        reported = key;
        clearTimeout(render.t);
        render.t = setTimeout(function () {
          track('calc_result', { calculator: 'seed', product_handle: product.handle, area_sq_ft: sqft, project: mode, quantity: plan.qty });
        }, 1200);
      }
    }

    root.querySelector('[data-eh-open]').addEventListener('click', function () {
      if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
      area.focus();
      track('calc_open', { calculator: 'seed', product_handle: product.handle });
    });
    root.querySelector('[data-eh-close]').addEventListener('click', function () {
      if (modal.close) modal.close(); else modal.removeAttribute('open');
    });
    modal.addEventListener('click', function (e) { if (e.target === modal && modal.close) modal.close(); });
    area.addEventListener('input', render);
    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () {
        mode = chip.getAttribute('data-eh-mode');
        Array.prototype.forEach.call(chips, function (c) { c.classList.toggle('is-on', c === chip); });
        render();
      });
    });
    apply.addEventListener('click', function () {
      if (!plan) return;
      var qty = plan.qty, variantId = plan.variant.id;
      if (String(variantId) !== currentVariantId()) selectVariant(plan.variant);
      // set the quantity after the theme has finished swapping the variant, then once more in
      // case the swap redrew the quantity field
      whenVariant(variantId, function () {
        setQuantity(qty);
        setTimeout(function () { setQuantity(qty); }, 900);
      });
      track('calc_set_qty', { calculator: 'seed', product_handle: product.handle, variant_id: String(variantId), quantity: qty });
      if (modal.close) modal.close(); else modal.removeAttribute('open');
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-eh-soil]'), initSoil);
    Array.prototype.forEach.call(document.querySelectorAll('[data-eh-seed]'), initSeed);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
